/**
 * Guest Cart Promo Guard
 *
 * 비로그인(customer == nil) 사용자가 카트에 promo·쿠폰·BXGY catalog-added GY 라인을
 * 갖고 있으면 자동 정리. cart-promo-cell dropdown 은 비로그인 시 미렌더이므로
 * 적용된 promo 유지 자체가 부정합 (사용자가 해제할 수단 없음).
 *
 * 트리거: 글로벌 (theme.liquid 에서 1회 인스턴스). SSR 단에서
 * data-needs-cleanup="true" 박을 때만 cleanup. flag=false 면 즉시 noop.
 *
 * 정리 로직은 window.CartPromoCleanup SSOT 헬퍼 호출 (cart-promo-cleanup.js).
 * 같은 헬퍼를 사원판매 모드 전환(employee-payment-popup.js) 도 사용 → 정책 SSOT.
 *
 * 회귀 정책 SSOT: wiki/docs/cart-promo-cleanup-policy.md (TBD)
 */

(function () {
  'use strict';

  class GuestCartPromoGuard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.needsCleanup !== 'true') return;
      if (this._ran) return;
      this._ran = true;
      this.runCleanup().catch((err) => console.warn('[guest-cart-promo-guard] cleanup failed', err));
    }

    async runCleanup() {
      const helper = window.CartPromoCleanup;
      if (!helper || typeof helper.run !== 'function') {
        console.warn('[guest-cart-promo-guard] CartPromoCleanup helper missing — load order 점검');
        return;
      }
      const result = await helper.run({ source: 'guest-guard' });
      if (!result.cleaned) return;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'guest-cart-promo-guard' } }));
      helper.refreshDrawerSections();
    }
  }

  if (!customElements.get('guest-cart-promo-guard')) {
    customElements.define('guest-cart-promo-guard', GuestCartPromoGuard);
  }
})();
